import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Health Net",
  shortName: "Health Net",
  slug: "health-net-insurance",
  seoTitle: "Health Net TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Health Net insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Health Net plan in Coral Springs, FL.",
  seoKeywords:
    "Health Net TMS coverage, Health Net TMS therapy, Health Net depression treatment Florida, Health Net mental health benefits Coral Springs FL, Health Net SAINT TMS",
  planType: "health insurance plan (Centene subsidiary)",
  planRegion: "California, Arizona, and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Health Net is a subsidiary of Centene Corporation, providing health insurance coverage primarily in California and Arizona. Health Net plans typically include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Health Net offers a variety of plan types — including HMO, PPO, and Medicare Advantage — and coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan and network.",
  officialResourceUrl: "https://www.healthnet.com/",
  officialResourceLabel: "Health Net official website",
};

export const HealthNetInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default HealthNetInsurance;
